import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PlatformService } from '../services/platform-service/platform.service';

export const integratorGuard: CanActivateFn = () => {
  return !inject(PlatformService).isMobile() || inject(Router).navigate(['/']);
};
